import { CoreView } from '@/components/Theme/Core/CoreView';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const View = withStyles(CoreView, {noSwitch: true});